var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDnbDoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.21 36.46"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "custom_dnb_door_svg__cls-1",
    d: "M14.37 3.58h11.57a.79.79 0 01.77.77V32.1a.76.76 0 01-.23.55.77.77 0 01-.54.22H14.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "custom_dnb_door_svg__cls-1",
    d: "M.5 32.45a.78.78 0 00.17.48.76.76 0 00.43.27l12.34 2.74a1 1 0 00.34 0 .89.89 0 00.31-.15.79.79 0 00.21-.27.75.75 0 00.07-.33V1.27a.75.75 0 00-.07-.33.71.71 0 00-.21-.27.89.89 0 00-.31-.15.65.65 0 00-.34 0L1.1 3.26a.76.76 0 00-.43.27A.78.78 0 00.5 4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "custom_dnb_door_svg__cls-1",
    d: "M9 20.54a2.31 2.31 0 10-2.31-2.31A2.3 2.3 0 009 20.54z"
  })))));
}

export default SvgCustomDnbDoor;